<div class="row">
  <div class="col-12">
    <div class="empty-state__card">
      <div class="empty-state__card__body">
        <h4 class="empty-state__card__body__headline">
          {{ "pages.transport.tracking-tabs.empty-state.title" | translate }}
        </h4>
        <p>
          {{ "pages.transport.tracking-tabs.empty-state.text" | translate }}
        </p>

        <h4 class="empty-state__card__body__headline">
          {{ "pages.transport.tracking-tabs.empty-state.tips.title" | translate }}
        </h4>

        <p>{{ "pages.transport.tracking-tabs.empty-state.tips.text" | translate }}</p>

        <ul>
          <li>{{ "pages.transport.tracking-tabs.empty-state.tips.line1" | translate }}</li>
          <li>{{ "pages.transport.tracking-tabs.empty-state.tips.line2" | translate }}</li>
          <li>{{ "pages.transport.tracking-tabs.empty-state.tips.line3" | translate }}</li>
          <li>{{ "pages.transport.tracking-tabs.empty-state.tips.line4" | translate }}</li>
          <li>{{ "pages.transport.tracking-tabs.empty-state.tips.line5" | translate }}</li>
          <li>{{ "pages.transport.tracking-tabs.empty-state.tips.line6" | translate }}</li>
        </ul>

        <p>{{ "pages.transport.tracking-tabs.empty-state.final" | translate }}</p>

        <p>{{ "pages.transport.tracking-tabs.empty-state.greetings" | translate }}</p>
      </div>
    </div>
  </div>
</div>
